"use client";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";
import Link from "next/link";
import { useAnalytics } from "@/components/providers/analytics-provider";

export function AdvertiseHeroSection() {
  const { trackTyped } = useAnalytics();
  return (
    <section className="relative overflow-hidden bg-linear-to-b from-muted/50 to-background dark:from-background dark:to-muted/20 py-20 md:py-32">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-foreground">
            Turn Your Plaster Business Into a{" "}
            <span className="text-primary">Customer Magnet</span>
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-10">
            Join America&apos;s #1 plaster and microcement applicator directory
            and start getting qualified customers who are ready to hire
            professional applicators today.
          </p>

          {/* Stats Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <Card className="p-6 mb-8 bg-card dark:bg-muted border border-border dark:border-muted shadow">
              <div className="text-5xl font-bold text-foreground mb-2">
                5,405+
              </div>
              <div className="text-sm text-muted-foreground">
                customers searching in the last 30 days
              </div>
              <div className="text-xs text-muted-foreground/80 mt-3 flex items-center justify-center gap-2">
                <span>📊</span>
                Real-time data from Google Analytics • Updates every 6 hours
              </div>
            </Card>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Button
              asChild
              size="lg"
              className="w-full sm:w-auto text-lg px-8"
              onClick={() =>
                trackTyped("advertise_cta_click", { cta_id: "signup" })
              }
            >
              <Link href="/signup">List Your Business Free</Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="w-full sm:w-auto text-lg px-8"
              onClick={() =>
                trackTyped("advertise_cta_click", { cta_id: "pricing" })
              }
            >
              <Link href="#pricing">View Pricing</Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
